import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  padding: 0;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  background-color: ${({ theme }) => theme.background};

  @media (min-width: 996px) {
    > p {
      display: none;
    }
  }

  @media (max-width: 996px) {
    margin-top: 2rem;
    width: 100vw;

    p {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      width: 100%;
      color: #fff;
      margin-top: auto;

      svg {
        margin-left: 8px;
        transform: rotateX(180deg);
      }
    }
  }
`;

export const GameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex: 1;

  @media (min-width: 996px) {
    &::before {
      content: '';
      width: 100%;
      height: 1.25rem;
      background: #9fa7f7;
    }
  }

  @media (max-width: 996px) {
    margin-top: 1rem;
  }

  > span {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  @media (min-width: 996px) {
    span {
      display: none;
    }
  }

  div {
    display: flex;

    main {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;

      img {
        height: 543px;

        @media (max-width: 1080px) {
          height: 516px;
        }

        @media (max-width: 1024px) {
          height: 480px;
        }

        @media (max-width: 996px) {
          height: 450px;
        }

        @media (max-width: 555px) {
          height: 300px;
        }
      }

      input {
        border-bottom: 1px solid ${({ theme }) => theme.text};
        width: 70%;
        max-width: 80%;
        text-align: center;
        text-transform: uppercase;
        font-size: 1.25rem;
        background-color: ${({ theme }) => theme.background};
      }

      @media (max-width: 996px) {
        input {
          margin-top: 1rem;
        }
      }

      @media (max-height: 500px) {
        padding: 0.25rem;

        .Numbering {
          font-size: 1.35rem;
        }

        img {
          max-width: 30%;
        }
      }

      @media (max-height: 400px) {
        img {
          max-width: 25%;
        }
      }

      @media (max-width: 300px) {
        img {
          max-width: 97%;
        }
      }
    }
  }
`;
